/* eslint-disable no-await-in-loop */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable arrow-body-style */
/* eslint-disable react/no-array-index-key */
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Chip,
  Divider,
  Grid,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import ImgsViewer from 'react-images-viewer';
import PrintIcon from '@mui/icons-material/Print';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Container } from 'reactstrap';
import moment from 'moment';
import UIContext from '../../context/UIContext';
import axios from '../../utils/axios';

import {
  showProgressToast,
  completeProgressToast,
  dismissProgressToast,
  updateProgressToast,
} from '../../components/Snackbar/toastHelpers';

const ViewInspection = () => {
  const { QAInspectionId } = useParams();
  // snackbar context
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);
  const [headerData, setHeaderData] = useState([]);
  const [inspectionData, setInspectionData] = useState([]);
  const [auditDataSummary, setAuditDataSummary] = useState([]);
  const [auditData, setAuditData] = useState([]);
  const [defectData, setDefectData] = useState([]);
  const [measurementData, setMeasurementData] = useState([]);
  const [cartonsData, setCartonsData] = useState([]);
  const [inspectionInfo, setInspectionInfo] = useState([]);
  const navigate = useNavigate(); // Initialize navigation

  useEffect(() => {
    getInspectionDetail();
  }, []);

  const getInspectionDetail = async () => {
    try {
      showLoading();
      const response = await axios.post('transaction/ManageInspection/GetInspectionDetails', { QAInspectionId });
      console.log(response.data);
      setHeaderData(response.data);
      setInspectionData(response.data.inspectionData);
      setAuditDataSummary(response.data.AuditData);
      setAuditData(response.data.AuditData);
      setDefectData(response.data.DefectsData);
      setMeasurementData(response.data.MeasurementChartData);
      setCartonsData(response.data.CartonData);
      setInspectionInfo(response.data.InspectionInfo);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  };

  const handlePrintClick = (Inspection) => {
    const toastId = Date.now();
    showProgressToast(toastId, 'Downloading Inspection Report...', 0);
    getInspectionDetialPDF(Inspection, toastId);
  };

  const getInspectionDetialPDF = async (Inspection, toastId) => {
    let progress = 0;
    let progressInterval;
    let downloadCompleted = false;
    let lastUpdateTime = Date.now();
    const { InspectionCode, QAInspectionId } = Inspection;
    try {
      // Start continuous progress animation
      progressInterval = setInterval(() => {
        if (downloadCompleted) return;

        // Calculate time-based progress (about 1-2 minutes to reach 90%)
        const elapsed = (Date.now() - lastUpdateTime) / 1000; // in seconds
        const timeBasedProgress = Math.min(90, elapsed * 0.75); // ~90% in 120 seconds

        // Add some randomness to make it feel more natural
        const randomFactor = 1 + (Math.random() * 0.2 - 0.1); // ±10% variation
        progress = Math.min(90, timeBasedProgress * randomFactor);

        updateProgressToast(toastId, Math.floor(progress), `Processing Inspection Report ${InspectionCode}`);
      }, 300);

      const response = await axios.post(
        'Report/Inspection/InspectionReportPDF',
        { QAInspectionId, recipientEmail: sessionStorage.getItem('UserEmail') },
        {
          responseType: 'blob',
          onDownloadProgress: (progressEvent) => {
            if (progressEvent.total) {
              const realProgress = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
              // If we have real progress, use it but keep it above our animated progress
              progress = Math.max(progress, Math.min(realProgress, 99));
              lastUpdateTime = Date.now(); // Reset the timer when we get real progress
            }
          },
        }
      );

      // Download complete - finish the animation
      downloadCompleted = true;
      clearInterval(progressInterval);

      // Animate from current progress to 100%
      while (progress < 100) {
        progress = Math.min(progress + 2, 100);
        updateProgressToast(
          toastId,
          Math.floor(progress),
          `Finalizing Inspection Report ${InspectionCode}... (${Math.floor(progress)}%)`
        );
        await new Promise((resolve) => setTimeout(resolve, 50));
      }

      completeProgressToast(toastId, `Inspection Report ${InspectionCode} Downloaded & Copy has been Sent in Email!`);

      const fileName = `Inspection-${Inspection.Buyer}-${Inspection.Styleno.replace(`/${Inspection.Ipono}`, '')}-${Inspection.TypesofInspection
        }-${Inspection.InspectionCode}-${moment(Inspection.QAInspectionDate).format('DD/MM/YYYY')}.pdf`
        .replace(/\s+/g, '')
        .replace(/\//g, '_');
      // Create and download the PDF
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();

      // Cleanup
      setTimeout(() => {
        link.remove();
        window.URL.revokeObjectURL(url);
      }, 200);
    } catch (e) {
      if (progressInterval) clearInterval(progressInterval);
      dismissProgressToast(toastId);

      const errorMsg = e.response?.data?.message || `Failed to download Inspection Report ${InspectionCode}`;

      openSnackBar(errorMsg, 'error');

    }
  };

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setSelectedImages([]);
  };

  const groupedAudits = useMemo(() => {
    const grouped = auditData.reduce((acc, item) => {
      const auditTypeId = String(item.AuditTypeId); // Ensure consistent key type

      if (!acc[auditTypeId]) {
        acc[auditTypeId] = {
          auditType: item.AuditType,
          overall: null,
          questions: [],
        };
      }

      if (item.Type?.toLowerCase() === 'overall') {
        acc[auditTypeId].overall = item;
      } else if (item.Type?.toLowerCase() === 'questions') {
        acc[auditTypeId].questions.push(item);
      }

      return acc;
    }, {});

    // Convert object to array and sort with 'remarks' first
    const sorted = Object.entries(grouped)
      .map(([auditTypeId, data]) => ({ auditTypeId, ...data }))
      .sort((a, b) => {
        const aType = a.auditType?.trim().toLowerCase();
        const bType = b.auditType?.trim().toLowerCase();
        if (aType === 'remarks') return -1;
        if (bType === 'remarks') return 1;
        return 0;
      });

    return sorted;
  }, [auditData]);

  // Calculate total defect counts
  const totalCritical = defectData.reduce((sum, defect) => sum + defect.Critical, 0);
  const totalMajor = defectData.reduce((sum, defect) => sum + defect.Major, 0);
  const totalMinor = defectData.reduce((sum, defect) => sum + defect.Minor, 0);

  const [viewerOpen, setViewerOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const [selectedImages, setSelectedImages] = useState([]);

  const handleOpenImages = (images, type) => {
    console.log('images', images);

    const imageURL =
      type === 'audit'
        ? axios.defaults.AuditImageURL
        : type === 'defect'
          ? axios.defaults.DefectImageURL
          : axios.defaults.MeasurementChartURL;

    // Convert string to array if necessary
    const imageArray = typeof images === 'string' ? images.split(',').map((img) => img.trim()) : images;

    if (Array.isArray(imageArray) && imageArray.length > 0) {
      setSelectedImages(imageArray.map((img) => ({ src: `${imageURL}/${img}` })));
      setCurrentImage(0);
      setViewerOpen(true);
    }
  };

  const handleOpenDocument = (docName) => {
    if (!docName) return;

    const documentURL = `${axios.defaults.MeasurementChartURL}/${docName}`;
    const fileExtension = docName.split('.').pop().toLowerCase();

    if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(fileExtension)) {
      // Open image in a modal viewer
      handleOpenImages([docName], 'measuremnet');
      // setSelectedImages([{ src: documentURL }]);
      // setViewerOpen(true);
    } else if (fileExtension === 'pdf') {
      // Open PDF in a new tab
      window.open(documentURL, '_blank');
    } else if (['doc', 'docx'].includes(fileExtension)) {
      // Open DOC/DOCX using Google Docs Viewer
      window.open(`https://docs.google.com/gview?url=${documentURL}&embedded=true`, '_blank');
    } else {
      alert('Unsupported file type');
    }
  };

  const handleCloseViewer = () => {
    setViewerOpen(false);
  };

  // ✅ Add onClickThumbnail function
  const handleThumbnailClick = (index) => {
    setCurrentImage(index);
  };

  return (
    <>
      <Container maxWidth={'xl'} elevation={3}>
        <Grid
          justifyContent={'space-between'}
          alignItems={'center'}
          spacing={2}
          sx={{ position: 'fixed', width: '100%', zIndex: viewerOpen ? 10 : 9700 }}
        >
          <Typography
            variant="h5"
            p={1}
            mx={2}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            color="white"
            sx={{
              background: '#2b5258',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="subtitle1" color="white" textAlign={'center'}>
              INSPECTION PREVIEW{' '}
              <Chip
                label={
                  inspectionData.Status?.trim() === 'P'
                    ? 'Pass'
                    : inspectionData.Status?.trim() === 'F'
                      ? 'Fail'
                      : 'Hold'
                }
                size="small"
                color={
                  inspectionData.Status?.trim() === 'P'
                    ? 'success'
                    : inspectionData.Status?.trim() === 'F'
                      ? 'error'
                      : 'warning'
                }
              />
            </Typography>
          </Typography>
        </Grid>
        <Stack m={3} pt={6}>
          <Box sx={{ display: 'flex', flexDirection: 'column', p: 2 }}>
            <Stack
              direction={{ xs: 'row', md: 'row' }}
              justifyContent={'space-between'}
              alignItems={'center'}
              spacing={2}
            >
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                justifyContent={'space-between'}
                alignItems={'center'}
                spacing={2}
              >
                <Box>
                  {QAInspectionId && (
                    <Typography variant="h6" color="GrayText">
                      INSPECTION NO : {inspectionData.InspectionCode}
                    </Typography>
                  )}
                </Box>
              </Stack>
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                justifyContent={'space-between'}
                alignItems={'center'}
                spacing={2}
              >
                <Box>
                  <Typography variant="h6" color="GrayText">
                    Date : <span>{inspectionData.QAInspectionDate}</span>
                  </Typography>
                </Box>
              </Stack>
            </Stack>

            <Divider sx={{ mb: 2 }}>
              <Chip label="Inspection Details" size="small" />
            </Divider>

            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Buyer
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {inspectionData.Buyer}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={12} md={4}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Factory
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {inspectionData.Factory}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={12} md={4}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Style / IPO
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {inspectionData.Styleno}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={6} md={4}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Inspection Type
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {inspectionData.InspectionType}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={6} md={4}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Level
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {inspectionData.Levelvalue}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={6} md={2}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      AQL Major
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {inspectionData.AQLMajor}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={6} md={2}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      AQL Minor
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {inspectionData.AQLMinor}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={6} md={6}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Assisting QA
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {inspectionData.AssistQAs}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={6} md={6}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Production Coordinators
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {inspectionData.CoordinatorNames}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <Divider sx={{ mt: 1 }}>
                  <Chip label="Order Summary" size="small" />
                </Divider>
              </Grid>
              <Grid item xs={12}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1} mb={1}>
                      Purchase Orders
                    </Typography>
                    <Stack direction="row" flexWrap="wrap" gap={1}>
                      {inspectionData.Pono?.split(',').map((po, index) => (
                        <Chip key={index} label={po.trim()} color="info" variant="outlined" size="small" />
                      ))}
                    </Stack>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={6} md={4}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Garment
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {inspectionData.GarmentDescription}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={6} md={4}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Fabric
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {inspectionData.FabricDescription}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={6} md={4}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Kimball
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {inspectionData.Kimball}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={6} md={2}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Division
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {inspectionData.Division}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={6} md={2}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Total Quantity
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {inspectionData.OrderQty}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={6} md={2}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      LOT Quantity
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {inspectionData.Lotqty}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={6} md={2}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Shipped Quantity
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {inspectionData.Shipqty}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={6} md={2}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Sample Quantity
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {inspectionData.SampleQuantity}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={6} md={2}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      (+/-) Quantity
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {inspectionData.PlusorMinusQuantity}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>

              {auditData && (
                <>
                  <Grid item xs={12}>
                    <Divider sx={{ mt: 1 }}>
                      <Chip label="Audit Summary" size="small" />
                    </Divider>
                  </Grid>
                  <Grid item xs={12}>
                    <Paper elevation={2} sx={{ bgcolor: 'inherit' }}>
                      {Object.keys(groupedAudits).map((auditTypeId) => {
                        const auditGroup = groupedAudits[auditTypeId];
                        return (
                          <Accordion key={auditTypeId} sx={{ bgcolor: 'inherit' }}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                              {auditGroup.overall && (
                                <>
                                  <Typography variant="h6" color={'#229799'}>
                                    {auditGroup.auditType}
                                    <Chip
                                      label={
                                        auditGroup.overall.AuditStatus.trim() === 'P'
                                          ? 'Pass'
                                          : auditGroup.overall.AuditStatus.trim() === 'F'
                                            ? 'Fail'
                                            : auditGroup.overall.AuditStatus.trim() === 'H'
                                              ? 'Hold'
                                              : 'N / A'
                                      }
                                      size="small"
                                      color={
                                        auditGroup.overall.AuditStatus.trim() === 'P'
                                          ? 'success'
                                          : auditGroup.overall.AuditStatus.trim() === 'F'
                                            ? 'error'
                                            : auditGroup.overall.AuditStatus.trim() === 'H'
                                              ? 'warning'
                                              : 'default'
                                      }
                                      sx={{ ml: 1 }}
                                    />{' '}
                                    <br />
                                    <Typography variant="body2">{auditGroup.overall.AuditComment}</Typography>
                                  </Typography>
                                </>
                              )}
                            </AccordionSummary>
                            <AccordionDetails>
                              <>
                                {' '}
                                <Divider sx={{ mb: 2 }}>
                                  <Chip label="Overview" size="small" />
                                </Divider>
                                {/* Question-based Audits */}
                                {auditGroup.questions.map((question, index) => (
                                  <Paper key={index} elevation={3} sx={{ p: 2, mb: 2, bgcolor: 'inherit' }}>
                                    <Grid container spacing={2}>
                                      {/* Left: Question & Comment */}
                                      <Grid item xs={6}>
                                        <Typography variant="subtitle2" color="GrayText">
                                          {question.Questionnaire || 'No Classification'}
                                        </Typography>
                                        <Typography variant="body2">{question.AuditComment}</Typography>
                                      </Grid>

                                      {/* Right: Result & View Images (Stacked) */}
                                      <Grid item xs={6} textAlign="right">
                                        <Stack spacing={1} alignItems="flex-end">
                                          {/* Audit Status */}
                                          <Chip
                                            label={
                                              question.AuditStatus.trim() === 'P'
                                                ? 'Pass'
                                                : question.AuditStatus.trim() === 'F'
                                                  ? 'Fail'
                                                  : question.AuditStatus.trim() === 'H'
                                                    ? 'Hold'
                                                    : 'N / A'
                                            }
                                            size="small"
                                            ss
                                            color={
                                              question.AuditStatus.trim() === 'P'
                                                ? 'success'
                                                : question.AuditStatus.trim() === 'F'
                                                  ? 'error'
                                                  : question.AuditStatus.trim() === 'H'
                                                    ? 'warning'
                                                    : 'info'
                                            }
                                          />

                                          {/* View Images Button */}
                                          {question.Images && (
                                            <Button
                                              size="small"
                                              onClick={() => handleOpenImages(question.Images, 'audit')}
                                            >
                                              View Images
                                            </Button>
                                          )}
                                        </Stack>
                                      </Grid>
                                    </Grid>
                                  </Paper>
                                ))}
                              </>
                            </AccordionDetails>
                          </Accordion>
                        );
                      })}
                    </Paper>
                  </Grid>
                </>
              )}
            </Grid>
            {defectData && (
              <>
                <Grid item xs={12}>
                  <Divider sx={{ my: 2 }}>
                    <Chip label="Defect Summary" size="small" />
                  </Divider>
                </Grid>
                <>
                  {defectData.length > 0 && (
                    <>
                      {defectData.map((defect, index) => {
                        const images = [defect.ImageURL1, defect.ImageURL2, defect.ImageURL3, defect.ImageURL4].filter(
                          Boolean
                        );

                        return (
                          <Paper elevation={2} key={index} sx={{ p: 2, bgcolor: 'inherit', mb: 2 }}>
                            <Grid container spacing={2} alignItems="center">
                              {/* Left Section: Category & Subcategory */}
                              <Grid item xs={6}>
                                <Typography variant="h6" color="#019267">
                                  {defect.SubCategoryDescription}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                  {defect.CategoryDescription}
                                </Typography>
                              </Grid>

                              {/* Right Section: Critical, Major, Minor, and View Images */}
                              <Grid item xs={6} sx={{ textAlign: 'right' }}>
                                <Stack direction="row" spacing={1} justifyContent="flex-end">
                                  <Chip label={`Critical: ${defect.Critical}`} color="error" size="small" />
                                  <Chip label={`Major: ${defect.Major}`} color="warning" size="small" />
                                  <Chip label={`Minor: ${defect.Minor}`} color="info" size="small" />
                                </Stack>

                                {/* View Images Button (below chips) */}
                                {images.length > 0 && (
                                  <Button
                                    size="small"
                                    sx={{ mt: 1 }}
                                    onClick={() => handleOpenImages(images, 'defect')}
                                  >
                                    View Images
                                  </Button>
                                )}
                              </Grid>
                            </Grid>
                          </Paper>
                        );
                      })}
                    </>
                  )}
                </>
              </>
            )}
            {measurementData && (
              <>
                <Grid item xs={12}>
                  <Divider sx={{ my: 2 }}>
                    <Chip label="Measurement Chart Summary" size="small" />
                  </Divider>
                </Grid>

                {measurementData.length > 0 &&
                  // eslint-disable-next-line arrow-body-style
                  measurementData.map((measurement, index) => {
                    return (
                      <Paper elevation={3} key={index} sx={{ p: 2, bgcolor: 'inherit', mb: 2 }}>
                        <Grid container spacing={2} alignItems="center">
                          {/* Left Section: Measurement Details */}
                          <Grid item xs={6}>
                            <Typography variant="h6" color="#27496D">
                              {measurement.MeasurementDescription}{' '}
                              <Chip
                                label={
                                  measurement.MeasurementStatus.trim() === 'P'
                                    ? 'Pass'
                                    : measurement.MeasurementStatus.trim() === 'F'
                                      ? 'Fail'
                                      : measurement.MeasurementStatus.trim() === 'H'
                                        ? 'Hold'
                                        : 'N / A'
                                }
                                size="small"
                                ss
                                color={
                                  measurement.MeasurementStatus.trim() === 'P'
                                    ? 'success'
                                    : measurement.MeasurementStatus.trim() === 'F'
                                      ? 'error'
                                      : measurement.MeasurementStatus.trim() === 'H'
                                        ? 'warning'
                                        : 'info'
                                }
                              />
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                              POM: {measurement.POM} | Garments Measured: {measurement.NoOfGarmentsMeasured}
                            </Typography>
                          </Grid>

                          {/* Right Section: Critical, Major, Minor + View Document */}
                          <Grid item xs={6} sx={{ textAlign: 'right' }}>
                            <Stack direction="row" spacing={1} justifyContent="flex-end">
                              <Chip label={`Critical: ${measurement.Critical}`} color="error" size="small" />
                              <Chip label={`Major: ${measurement.Major}`} color="warning" size="small" />
                              <Chip label={`Minor: ${measurement.Minor}`} color="info" size="small" />
                            </Stack>

                            {/* View Document Button (if available) */}
                            {measurement.DocumentName && (
                              <Button
                                size="small"
                                sx={{ mt: 1 }}
                                onClick={() => handleOpenDocument(measurement.DocumentName)}
                              >
                                View Document
                              </Button>
                            )}
                          </Grid>
                        </Grid>
                      </Paper>
                    );
                  })}
              </>
            )}
            {cartonsData && (
              <>
                <Grid item xs={12}>
                  <Divider sx={{ my: 2 }}>
                    <Chip label="Carton Summary" size="small" />
                  </Divider>
                </Grid>
                {cartonsData.length > 0 &&
                  cartonsData.map((carton, index) => {
                    return (
                      <Paper elevation={3} key={index} sx={{ p: 2, bgcolor: 'inherit', mb: 2 }}>
                        <Grid container spacing={2} alignItems="center">
                          {/* Left Section: PO Number & Carton Numbers */}
                          <Grid item xs={6}>
                            <Typography variant="subtitle2" color="#019267">
                              PO Numbers :{' '}
                              <Stack direction="row" flexWrap="wrap" gap={1}>
                                {carton.PoNo?.split(',').map((po, index) => (
                                  <Chip key={index} label={po.trim()} variant="outlined" size="small" />
                                ))}
                              </Stack>
                              {/* PO: {carton.PoNo} */}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                              Carton Numbers: {carton.CartonNumbers}
                            </Typography>
                          </Grid>

                          {/* Right Section: Shipped, Pulled, Passed, Failed */}
                          <Grid item xs={6} sx={{ textAlign: 'right' }}>
                            <Stack direction="row" spacing={1} justifyContent="flex-end">
                              <Chip label={`Shipped: ${carton.ShippedCartonCount}`} color="primary" size="small" />
                              <Chip label={`Pulled: ${carton.PulledCartonCount}`} color="warning" size="small" />
                              <Chip label={`Passed: ${carton.PassedCartonCount}`} color="success" size="small" />
                              <Chip label={`Failed: ${carton.FailedCartonCount}`} color="error" size="small" />
                            </Stack>
                          </Grid>
                        </Grid>
                      </Paper>
                    );
                  })}
              </>
            )}
            {inspectionInfo && (
              <>
                <Grid item xs={12}>
                  <Divider sx={{ my: 2 }}>
                    <Chip label="Box Control & Inspection Info" size="small" />
                  </Divider>
                </Grid>

                {/* Box Control Data */}
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Paper elevation={3} sx={{ p: 2, textAlign: 'center', bgcolor: 'inherit' }}>
                      <Typography variant="body1" fontWeight="bold">
                        Total No. of Cartons
                      </Typography>
                      <Typography variant="h6" color="primary">
                        {inspectionInfo.TotalNoOfCartons}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={4}>
                    <Paper elevation={3} sx={{ p: 2, textAlign: 'center', bgcolor: 'inherit' }}>
                      <Typography variant="body1" fontWeight="bold">
                        No. of Cartons Selected
                      </Typography>
                      <Typography variant="h6" color="primary">
                        {inspectionInfo.NoOfCartonSelected}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={4}>
                    <Paper elevation={3} sx={{ p: 2, textAlign: 'center', bgcolor: 'inherit' }}>
                      <Typography variant="body1" fontWeight="bold">
                        Ready Carton % to Inspect
                      </Typography>
                      <Typography variant="h6" color="primary">
                        {inspectionInfo.CartonPerToInspect}%
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>

                {/* General Info */}
                <Paper elevation={3} sx={{ p: 3, mt: 2, bgcolor: 'inherit' }}>
                  <Divider sx={{ mb: 1 }}>
                    <Chip label="General Summary" size="small" />
                  </Divider>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Typography variant="body1">
                        <b>Country of Origin:</b> {inspectionInfo.CountryofOrigin}
                      </Typography>
                      <Typography variant="body1">
                        <b>Size to Size (size range in the spec):</b> {inspectionInfo.SizetoSize}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body1">
                        <b>Actual GSM:</b> {inspectionInfo.ActualGSMCount}
                      </Typography>
                      {/* <Typography variant="body1">
                        <b>Remarks:</b> {inspectionInfo.Remarks}
                      </Typography> */}
                      <Typography variant="body1">
                        <b>Measurement (size range in the PO):</b> {inspectionInfo.Measurement}
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
                <Paper elevation={3} sx={{ p: 3, mt: 2, bgcolor: 'inherit' }}>
                  <Divider sx={{ mb: 1 }}>
                    <Chip label="Results" size="small" />
                  </Divider>
                  {/* Critical, Major, Minor Counts */}
                  <Grid container spacing={2} sx={{ mt: 2 }}>
                    {/* Critical Count */}
                    <Grid item xs={4}>
                      <Paper
                        elevation={3}
                        sx={{ bgcolor: '#ffa48d5e', color: 'error.dark', textAlign: 'center', p: 2, borderRadius: 2 }}
                      >
                        <Typography variant="body1" fontWeight="bold">
                          Critical
                        </Typography>
                        <Typography variant="h6" fontWeight="bold">
                          {totalCritical}
                        </Typography>
                      </Paper>
                    </Grid>

                    {/* Major Count */}
                    <Grid item xs={4}>
                      <Paper
                        elevation={3}
                        sx={{
                          bgcolor: '#ffe16a70',
                          color: 'warning.dark',
                          textAlign: 'center',
                          p: 2,
                          borderRadius: 2,
                        }}
                      >
                        <Typography variant="body1" fontWeight="bold">
                          Major
                        </Typography>
                        <Typography variant="h6" fontWeight="bold">
                          {totalMajor}
                        </Typography>
                      </Paper>
                    </Grid>

                    {/* Minor Count */}
                    <Grid item xs={4}>
                      <Paper
                        elevation={3}
                        sx={{ bgcolor: '#74caff6b', color: 'info.dark', textAlign: 'center', p: 2, borderRadius: 2 }}
                      >
                        <Typography variant="body1" fontWeight="bold">
                          Minor
                        </Typography>
                        <Typography variant="h6" fontWeight="bold">
                          {totalMinor}
                        </Typography>
                      </Paper>
                    </Grid>
                  </Grid>
                </Paper>
                {/* Factory & Inspector Signatures */}
                <Paper elevation={3} sx={{ p: 3, mt: 2, bgcolor: 'inherit' }}>
                  <Divider sx={{ mb: 1 }}>
                    <Chip label="Declarations" size="small" />
                  </Divider>

                  <Grid container spacing={2} alignItems="start">
                    {/* Factory Representative (Left Corner) */}
                    <Grid item xs={6} sx={{ textAlign: 'left' }}>
                      <Typography variant="body1">
                        <b>Factory Representative:</b> {inspectionInfo.FactoryRepresentative}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {inspectionInfo.FactoryRepresentativeDesig}
                      </Typography>
                      <img
                        // src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRfjQJq51Lk7mSuB9RpsA8OuE7QixuVFnejmg&s"
                        src={`${axios.defaults.InspectionInfoImageURL}/${inspectionInfo.FactoryRepresentativeSign}`}
                        alt="Factory Representative Signature"
                        style={{ width: 120, marginTop: 8, mixBlendMode: 'multiply' }}
                      />
                      <Typography
                        variant="body2"
                        sx={{ fontStyle: 'italic', color: 'gray', textAlign: 'left' }}
                      >
                        {inspectionInfo.TermsAndConditions}
                      </Typography>
                    </Grid>

                    {/* Vertical Divider */}
                    {/* <Grid item xs={2}>
                      <Divider orientation="vertical" flexItem />
                    </Grid> */}

                    {/* Inspector Signature (Right Corner) */}
                    <Grid item xs={6} sx={{ textAlign: 'right' }}>
                      <Typography variant="body1" fontWeight="bold">
                        Digital Signature of Inspector
                      </Typography>
                      <img
                        // src="https://cdn.kwork.com/files/portfolio/t3/73/cover-12253669-1709664496.jpg"
                        src={`${axios.defaults.InspectionInfoImageURL}/${inspectionInfo.InspectorSign}`}
                        alt="Inspector Signature"
                        style={{
                          width: 120,
                          marginTop: 8,
                          display: 'block',
                          marginLeft: 'auto',
                          mixBlendMode: 'multiply',
                        }}
                      />
                      {/* <Typography
                        variant="body2"
                        sx={{ mt: 1, fontStyle: 'italic', color: 'gray', textAlign: 'right' }}
                      >
                        {inspectionInfo.TermsAndConditions}
                      </Typography> */}
                    </Grid>
                    {/* <Grid item xs={6}>

                    </Grid> */}
                  </Grid>


                </Paper>
              </>
            )}
            <Stack direction="row" justifyContent={'center'} alignItems={'center'} spacing={2} mt={3}>
              <Button variant="contained" color="primary" onClick={() => navigate(-1)}>
                Back
              </Button>
              <Button
                variant="contained"
                color="warning"
                startIcon={<PrintIcon />}
                onClick={() => {
                  handlePrintClick(inspectionData);
                }}
              >
                Print
              </Button>
            </Stack>
          </Box>
        </Stack>
        <ImgsViewer
          imgs={selectedImages}
          isOpen={viewerOpen}
          currImg={currentImage}
          onClickPrev={() => setCurrentImage((prev) => (prev > 0 ? prev - 1 : prev))}
          onClickNext={() => setCurrentImage((prev) => (prev < selectedImages.length - 1 ? prev + 1 : prev))}
          onClose={handleCloseViewer}
          showThumbnails={true}
          onClickThumbnail={handleThumbnailClick}
          enableZoom={true}
        />
      </Container>
    </>
  );
};

export default ViewInspection;
